import { usePrismicDocumentByUID } from "../prismic-hooks";
import React from "react";
import PageContent from "../components/PageContent";

export default function AboutUs() {
    const [document] = usePrismicDocumentByUID('gcc_content_page', 'about-us');
    return <PageContent document={document} sectionClass='about-us' />;
}